module.exports = __webpack_public_path__ + "site/img/78.06d705b4.jpg";